<app-ibase-crud-content [deleteRenforced]="true" [showHelpButton]="true"></app-ibase-crud-content>

<!-- BUGFIX: p-message disapear on modal close, making DOM dialog dynamic fix it -->
@if (helpVisible) {
    <p-dialog
        header="Help"
        [modal]="true"
        [(visible)]="helpVisible"
        [resizable]="true"
        [maximizable]="true"
        appendTo="body"
    >
        <div>
            <p>
                This component allow you to create OO8 Connectors, those connector are then used by customers to
                interact with an OO8 instance
            </p>

            <div class="p-dialog-footer">
                <p-button
                    severity="secondary"
                    icon="pi pi-times"
                    type="button"
                    label="Close"
                    (click)="helpVisible = false"
                />
            </div>
        </div>
    </p-dialog>
}
